PIXI.spine.core.AnimationState.prototype.applyMixingFrom = function (to, skeleton, blend) {
  let from = to.mixingFrom;
  if (from.mixingFrom != null) this.applyMixingFrom(from, skeleton, blend);

  let mix = 0;
  if (to.mixDuration == 0) { // Single frame mix to undo mixingFrom changes.
    mix = 1;
    if (blend == PIXI.spine.core.MixBlend.first) blend = PIXI.spine.core.MixBlend.setup;
  } else {
    mix = to.mixTime / to.mixDuration;
    if (mix > 1) mix = 1;
    if (blend != PIXI.spine.core.MixBlend.first) blend = from.mixBlend;
  }

  let events = mix < from.eventThreshold ? this.events : null;
  let attachments = mix < from.attachmentThreshold, drawOrder = mix < from.drawOrderThreshold;
  let animationLast = from.animationLast, animationTime = from.getAnimationTime(), applyTime = animationTime;
  let timelineCount = from.animation.timelines.length;
  let timelines = from.animation.timelines;
  let alphaHold = from.alpha * to.interruptAlpha, alphaMix = alphaHold * (1 - mix);

  if (from.reverse) {
    applyTime = from.animation.duration - applyTime;
  } else {
    if (mix < from.eventThreshold) events = this.events;
  }

  if (blend == PIXI.spine.core.MixBlend.add) {
    for (let i = 0; i < timelineCount; i++)
      timelines[i].apply(skeleton, animationLast, applyTime, events, alphaMix, blend, PIXI.spine.core.MixDirection.mixOut);
  } else {
    let timelineMode = from.timelineMode;
    let timelineHoldMix = from.timelineHoldMix;

    let firstFrame = from.timelinesRotation.length == 0;
    if (firstFrame) PIXI.spine.core.Utils.setArraySize(from.timelinesRotation, timelineCount << 1, null);
    let timelinesRotation = from.timelinesRotation;

    from.totalAlpha = 0;
    for (let i = 0; i < timelineCount; i++) {
      let timeline = timelines[i];
      let direction = PIXI.spine.core.MixDirection.mixOut;
      let timelineBlend;
      let alpha = 0;
      switch (timelineMode[i] & (PIXI.spine.core.AnimationState.NOT_LAST - 1)) {
        case PIXI.spine.core.AnimationState.SUBSEQUENT:
          timelineBlend = blend;
          if (!attachments && timeline instanceof PIXI.spine.core.AttachmentTimeline) {
            if ((timelineMode[i] & PIXI.spine.core.AnimationState.NOT_LAST) == PIXI.spine.core.AnimationState.NOT_LAST) continue;
            timelineBlend = PIXI.spine.core.MixBlend.setup;
          }
          if (!drawOrder && timeline instanceof PIXI.spine.core.DrawOrderTimeline) continue;
          alpha = alphaMix;
          break;
        case PIXI.spine.core.AnimationState.FIRST:
          timelineBlend = PIXI.spine.core.MixBlend.setup;
          alpha = alphaMix;
          break;
        case PIXI.spine.core.AnimationState.HOLD:
          timelineBlend = PIXI.spine.core.MixBlend.setup;
          alpha = alphaHold;
          break;
        default: {
          timelineBlend = PIXI.spine.core.MixBlend.setup;
          let holdMix = timelineHoldMix[i];
          alpha = alphaHold * Math.max(0, 1 - holdMix.mixTime / holdMix.mixDuration);
          break;
        }
      }
      from.totalAlpha += alpha;
      if (timeline instanceof PIXI.spine.core.RotateTimeline)
        this.applyRotateTimeline(timeline, skeleton, applyTime, alpha, timelineBlend, timelinesRotation, i << 1, firstFrame);
      else {
        // This fixes the WebKit 602 specific issue described at http://esotericsoftware.com/forum/iOS-10-disappearing-graphics-10109
        PIXI.spine.core.Utils.webkit602BugfixHelper(alpha, blend);
        if (timelineBlend == PIXI.spine.core.MixBlend.setup) {
          if (timeline instanceof PIXI.spine.core.AttachmentTimeline) {
            if (attachments || (timelineMode[i] & PIXI.spine.core.AnimationState.NOT_LAST) == PIXI.spine.core.AnimationState.NOT_LAST) direction = PIXI.spine.core.MixDirection.mixIn;
          } else if (timeline instanceof PIXI.spine.core.DrawOrderTimeline) {
            if (drawOrder) direction = PIXI.spine.core.MixDirection.mixIn;
          }
        }
        timeline.apply(skeleton, animationLast, applyTime, events, alpha, timelineBlend, direction);
      }
    }
  }

  if (to.mixDuration > 0) this.queueEvents(from, animationTime);
  this.events.length = 0;
  from.nextAnimationLast = animationTime;
  from.nextTrackLast = from.trackTime;

  return mix;
};

PIXI.spine.core.AnimationState.prototype.apply = function (skeleton) {
  if (skeleton == null) throw new Error('skeleton cannot be null.');
  if (this.animationsChanged) this._animationsChanged();

  let events = this.events;
  let tracks = this.tracks;
  let applied = false;

  for (let i = 0, n = tracks.length; i < n; i++) {
    let current = tracks[i];
    if (current == null || current.delay > 0) continue;
    applied = true;
    let blend = i == 0 ? PIXI.spine.core.MixBlend.first : current.mixBlend;

    // Apply mixing from entries first.
    let mix = current.alpha;
    if (current.mixingFrom != null)
      mix *= this.applyMixingFrom(current, skeleton, blend);
    else if (current.trackTime >= current.trackEnd && current.next == null)
      mix = 0;

    // Apply current entry.
    let animationLast = current.animationLast, animationTime = current.getAnimationTime(), applyTime = animationTime;
    let applyEvents = events;
    if (current.reverse) {
      applyTime = current.animation.duration - applyTime;
      applyEvents = null;
    }
    let timelineCount = current.animation.timelines.length;
    let timelines = current.animation.timelines;
    if ((i == 0 && mix == 1) || blend == PIXI.spine.core.MixBlend.add) {
      for (let ii = 0; ii < timelineCount; ii++) {
        // Fixes issue #302 on IOS9 where mix, blend sometimes became undefined and caused assets
        // to sometimes stop rendering when using color correction, as their RGBA values become NaN.
        // (https://github.com/pixijs/pixi-spine/issues/302)
        PIXI.spine.core.Utils.webkit602BugfixHelper(mix, blend);
        timelines[ii].apply(skeleton, animationLast, applyTime, applyEvents, mix, blend, PIXI.spine.core.MixDirection.mixIn);
      }
    } else {
      let timelineMode = current.timelineMode;

      let firstFrame = current.timelinesRotation.length == 0;
      if (firstFrame) PIXI.spine.core.Utils.setArraySize(current.timelinesRotation, timelineCount << 1, null);
      let timelinesRotation = current.timelinesRotation;

      for (let ii = 0; ii < timelineCount; ii++) {
        let timeline = timelines[ii];
        let timelineBlend = (timelineMode[ii] & (PIXI.spine.core.AnimationState.NOT_LAST - 1)) == PIXI.spine.core.AnimationState.SUBSEQUENT ? blend : PIXI.spine.core.MixBlend.setup;
        if (timeline instanceof PIXI.spine.core.RotateTimeline) {
          this.applyRotateTimeline(timeline, skeleton, applyTime, mix, timelineBlend, timelinesRotation, ii << 1, firstFrame);
        } else {
          // This fixes the WebKit 602 specific issue described at http://esotericsoftware.com/forum/iOS-10-disappearing-graphics-10109
          PIXI.spine.core.Utils.webkit602BugfixHelper(mix, blend);
          timeline.apply(skeleton, animationLast, applyTime, applyEvents, mix, timelineBlend, PIXI.spine.core.MixDirection.mixIn);
        }
      }
    }
    this.queueEvents(current, animationTime);
    events.length = 0;
    current.nextAnimationLast = animationTime;
    current.nextTrackLast = current.trackTime;
  }

  this.queue.drain();
  return applied;
};
